export function notificationStatusLabel(status) {
  if (status === "delivered") return "Delivered";
  if (status === "sent") return "Sent";
  if (status === "failed" || status === "bounced" || status === "complained") return "Failed";
  if (status === "queued" || status === "processing") return "Pending delivery";
  if (status === "unconfigured") return "Pending delivery";
  return status || "Unknown";
}
